import {
  administrative,
  declareFieldMeanings,
  identity,
  means,
} from '../../../src/issues/field-meanings';

/** What each fire violation detail means to an owner. */
export const fieldMeanings = declareFieldMeanings({
  sources: ['fire-violations'],
  declarations: [
    identity(
      'violation_id',
      'number',
      'violation_number',
      'inspectionNumber',
      'inspection_number',
      'address',
      'block',
      'lot',
      'street_name',
      'street_number_low',
      'street_number_high',
      'street_suffix',
      'unit',
    ),
    administrative(
      'latitude',
      'longitude',
      'data_as_of',
      'data_loaded_at',
      ':id',
      ':created_at',
      ':updated_at',
    ),
    means('status', 'the violation status', ['status']),
    means('date', 'the violation date', ['violationDate', 'violation_date']),
    means('date', 'the close date', ['closeDate', 'close_date'], {
      matters: 'changes when the fire department counts the violation as closed',
    }),
    means(
      'description',
      'how the fire department describes the violation',
      ['description', 'violation_item_description'],
      {
        matters: 'restated what it found',
        means:
          "This is the fire department's description of the violation. A change means it restated what it found.",
      },
    ),
    means(
      'description',
      'the corrective action it requires',
      ['correctiveAction', 'corrective_action'],
      {
        matters: 'changed what it requires of you',
        means:
          'This is what the fire department requires the owner to do. A change means the required work changed.',
      },
    ),
    means('detail', 'the code section cited', ['violation_item'], {
      matters: 'changes which rule the violation is under',
    }),
  ],
});
